<template>
  <div>
    <Question v-if="['feedback'].indexOf($route.name)"/>
    <Feedback v-if="['question'].indexOf($route.name)"/>
    <!-- <Promotion /> -->
  </div>
</template>

<script>
import Question from '../components/questions/Question';
import Feedback from '../components/questions/Feedback';
import Promotion from '../components/Promotion';

export default {
  data() {
    return {
      // questions: Questions
    };
  },
  components: {
    Question,
    Feedback,
    Promotion,
  },
  computed: {
    question() {
      const questionNumber = this.$route.params.id - 1;
      return this.$store.state.questions[questionNumber];
    },
  },
};
</script>

<style scoped>
  .v-carousel {
    background: palevioletred;
  }
</style>



// WEBPACK FOOTER //
// src/views/Questions.vue